import React from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import { Link } from '../../routes';

const InlineLink = (props) => {
  const { href, children, ...rest } = props;

  if (!href) return null;

  const formatInternal = href.replace(/https?:\/\/(www\.)?wavesforwater\.org\/?/g, '/');

  if (href === 'https://www.dockers.com/US/en_US/features/dockers-waves-for-water') {
    return (
      <a
        {...rest}
        href={href}
        target="_blank"
        rel="noreferrer noopener"
        onClick={() => {
          ReactGA.event({
            category: 'Dockers',
            action: 'Dockers Website Link Clicked',
          });
        }}
      >
        {children}
      </a>
    );
  }

  return (
    formatInternal.match(/^(https?:)?\/\/|mailto:/)
      ? <a {...rest} href={formatInternal} target="_blank" rel="noreferrer noopener">{children}</a>
      : <Link route={formatInternal}><a {...rest}>{children}</a></Link>
  );
};

InlineLink.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default InlineLink;
